import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export function setUserOnline(user) {
  if (!user) return;
  const userRef = doc(db, "users", user.uid);
  setDoc(userRef, {
    email: user.email,
    online: true,
    lastActive: serverTimestamp(),
  }, { merge: true });
}

export function setUserOffline(user) {
  if (!user) return;
  const userRef = doc(db, "users", user.uid);
  setDoc(userRef, {
    online: false,
    lastActive: serverTimestamp(),
  }, { merge: true });
} 